import React,{useEffect} from 'react';
import PropTypes from 'prop-types';
import { Field,change } from 'redux-form';
import { Label } from 'reactstrap';
import SearchableSelect from '../fields/SearchableSelect';
import * as Validators from '../../util/Validators';
import {
  isImportAndContainer,
  isExportAndContainer,
  isImportJobType,
  isExportAndLogs,
} from '../../util/JobTypeHelper';
import {fumigantWarehouseLocation, mbDescription} from '../../constants/ListConstants'

import RenderField from './RenderField';
import CheckboxField from './CheckboxField';

import ToggleButton from '../layout/ToggleButton';

import styles from './MarkingsFieldArray.module.scss';

import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

const propTypes = {
  // label: PropTypes.string,
  // fields: PropTypes.object.isRequired,
  // meta: PropTypes.object.isRequired,
};

const selector = formValueSelector('treatmentResultRecordsForm');
const mapStateToProps = (state) => {
  var markings = selector(state, 'mbBottles');
  if(markings == undefined){
markings = selector(state, 'fumigantDetails')
  }


  return {markings};
};


function MBMarkingsFieldArray({ fields, meta: { error }, label, markings,config,change }) {
      const getCurrentState =  config? config.currentState?config.currentState:null:null;
     const totalMbUsage = (markings || []).reduce((sum, item) => {
  const value = parseFloat(item.mbUsage);
  return sum + (isNaN(value) ? 0 : value);
}, 0);

     if(markings && config.treatmentResultRecords ){
      useEffect(() => {
  change('treatmentResultRecordsForm', 'mbkg', totalMbUsage);
}, [totalMbUsage, change]);
     }
  const addNewMarking = (e) => {
    if (e.which === 13 || e.keyCode === 13) {
      e.preventDefault();
      fields.push({});
    }
  };

  
   return (
    
    <div className={styles.mbMarkingsFieldArray}>
    
      {label && <Label className={styles.mbLabel}>{label}</Label>}

      {fields.map((mbJson, index) => {

    const eralisUpdated = markings[index].eralisUpdated?markings[index].eralisUpdated: false;
    //console.log('markingsMBBottle',markings)

        return (
          <div key={index} className={styles.mbMarkingItem}>
    
            <Field
              name={`${mbJson}.description`}
              component={SearchableSelect}
              options={mbDescription}
              valueKey="value"
              labelKey="label"
              placeholder="Description"
              className={styles.wideSelect}
              validate={Validators.mandatoryList}
             disabled={eralisUpdated}
            />
            <Field
              name={`${mbJson}.mbJson`}
              type="text"
              component={RenderField}
              placeholder={'Enter Bottle No.'}
              onKeyPress={addNewMarking}
              validate={Validators.requiredTrue}
              readOnly={eralisUpdated}
            />
            <Field
              name={`${mbJson}.mbUsage`}
              type="number"
              component={RenderField}
              placeholder="Usage Kg"
              onKeyPress={addNewMarking}
              validate={Validators.requiredTrue}
              readOnly={eralisUpdated}
            />
               <Field
              name={`${mbJson}.eralisUpdated`}
                type="text"
              component={RenderField}
              hidden={true}
            />
          {eralisUpdated?
           (
      <span
        style={{
          color: "red",
          fontSize: "18px",
          fontWeight: "bold"
        }}
      >
        Posted
      </span>
    )
          :
            <span
              title="Remove Marking"
              aria-label="Clear value"
              onClick={() => fields.remove(index)}
            >
              <span className={styles.clear}>×</span>
            </span>
      }
          </div>
        );
      })}
    {getCurrentState === 'in progress' || getCurrentState === 'assigned'?
      <ToggleButton
        className={styles.addButton}
        color="light"
        onClick={() => fields.push({})}
        ligature="add"
      />
      :null}
    </div>
  );
}

MBMarkingsFieldArray.propTypes = propTypes;

export default connect(mapStateToProps,{change})(MBMarkingsFieldArray);
